import { render, staticRenderFns } from "./affiliate.vue?vue&type=template&id=1845cea0&"
import script from "./affiliate.vue?vue&type=script&lang=js&"
export * from "./affiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports